import { Typography } from '@mui/material';

interface Props {
  title: string;
}

export const AppFormLabel = ({ title }: Props) => {
  return (
    <Typography variant="h6" color={'primary'}>
      {title}
    </Typography>
  );
};
